"use client"

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Badge } from "@/components/ui/badge"
import { format } from "date-fns"
import { Payment } from "@/types"

interface PaymentsHistoryTabProps {
  payments: Payment[];
}

export function PaymentsHistoryTab({ payments }: PaymentsHistoryTabProps) {
  if (!payments || payments.length === 0) {
    return <div className="text-center text-muted-foreground p-4">No payment history found.</div>
  }
  
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Amount Paid</TableHead>
            <TableHead>Amount Due</TableHead>
            <TableHead>Method</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {payments.map((payment) => (
            <TableRow key={payment.id}>
              <TableCell>{format(new Date(payment.created_at), "PPP")}</TableCell>
              <TableCell>Rs. {payment.amount_paid.toLocaleString()}</TableCell>
              <TableCell>Rs. {payment.amount_due.toLocaleString()}</TableCell>
              <TableCell>{payment.payment_method || 'N/A'}</TableCell>
              <TableCell><Badge variant={payment.status === 'completed' ? 'default' : 'secondary'}>{payment.status}</Badge></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
} 